import { render } from "./dashboard.vue?vue&type=template&id=3bfec899&scoped=true&ts=true&lang=pug"
import script from "./dashboard.vue?vue&type=script&lang=ts"
export * from "./dashboard.vue?vue&type=script&lang=ts"

import "./dashboard.vue?vue&type=style&index=0&id=3bfec899&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfec899"]])

export default __exports__